export const USER_INFO_FORCED_FIELDS = {
  company: [
    'nationalNumber',
    'companyName',
    'province',
    'city',
    'address',
    'postalCode',
  ],
  person: ['id', 'birthDate', 'residencePostalCode'],
};
